import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IPlayersStore, IPlayer} from "data/stores/players/players.store";
import {PlayerPosition} from "data/enums";
import type {ISquadsStore, ISquad} from "data/stores/squads/squads.store";
import {Empty} from "data/types/global";

interface IParams {
	playerId: number;
}

export interface IPlayersBarPlayerController extends ViewController<IParams> {
	readonly i18n: ILocalizationStore;

	get squad(): Empty<ISquad>;
	get player(): IPlayer | undefined;

	get isPitcher(): boolean;
	get isOnFire(): boolean;
}

@injectable()
export class PlayersBarPlayerController implements IPlayersBarPlayerController {
	@observable private _playerID: number = 0;

	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.PlayersStore) public readonly _playersStore: IPlayersStore,
		@inject(Bindings.SquadsStore) public readonly _squadsStore: ISquadsStore
	) {
		makeAutoObservable(this);
	}

	get squad() {
		return this._squadsStore.getSquadById(this.player?.squadId);
	}

	get player(): IPlayer | undefined {
		return this._playersStore.getPlayerById(this._playerID);
	}

	get isPitcher(): boolean {
		return this.player?.position === PlayerPosition.Pitcher;
	}

	get isOnFire(): boolean {
		return this.player?.position === PlayerPosition.Pitcher;
	}

	init(param: IParams) {
		this._playerID = param.playerId;
	}

	onChange(param: IParams) {
		this._playerID = param.playerId;
	}
}
